(() => {
  'use strict';
  const hero = document.querySelector('[data-bzn-browse-hero]');
  if (!hero) return;
  const $ = (s, root = hero) => root.querySelector(s);
  const $$ = (s, root = hero) => [...root.querySelectorAll(s)];
  const slides = $$('.bzn-browse-hero__slide');
  if(!slides.length)return;
  const radios = $$('.bzn-browse-hero__radio');
  const dots = $$('[data-zx-story-dot]');
  const storyButtons = [...document.querySelectorAll('[data-zx-story]')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const interval = 8000;
  const fadeDuration = 1800;
  let paused = reduced.matches, timer, revision = 0, visible = false, groupOffset = 0;
  const visiblePhotos = new Set();
  const productOffsets = new Map();
  const transitions = new Map();
  let story = 0;
  const photoButtons = () => $$('[data-zx-hero-animal]', slides[story]);
  const available = p => p.image && (p.variants || []).some(v => v.available);
  const canRotate = () => !paused && visible && !document.hidden && !document.querySelector('dialog[open]') && photoButtons().length > 0 && !photoButtons().some(n => n.matches(':hover') || n.contains(document.activeElement));
  function schedule() {
    clearTimeout(timer); revision++;
    transitions.forEach(transition => transition.settle());
    if (canRotate()) timer = setTimeout(rotatePhotos, interval);
  }
  function setPaused(value) { paused = value; schedule(); }
  // Hero photo pool (2026-09-30): newest in-stock New Arrivals with tall, high-resolution
  // photos, chosen in snippets/bz-v4-page.liquid. Rotation walks this list first and only
  // falls back to the whole catalog when the pool runs short.
  const poolHandles = (() => {
    try { return JSON.parse(document.querySelector('[data-bz-hero-pool]')?.textContent || '[]'); } catch { return []; }
  })();
  let poolOffset = 0;
  function nextPoolProducts(buttons, catalog) {
    if (!poolHandles.length) return [];
    const byHandle = new Map(catalog.map(p => [p.handle, p]));
    const pool = poolHandles.map(handle => byHandle.get(handle)).filter(Boolean);
    const showing = new Set(buttons.map(n => n.dataset.zQuick));
    const picks = [];
    for (let i = 0; i < pool.length && picks.length < buttons.length; i++) {
      const p = pool[poolOffset++ % pool.length];
      if (showing.has(p.id) || picks.includes(p)) continue;
      picks.push(p);
    }
    return picks.length === buttons.length ? picks : [];
  }
  // Give animal groups equal turns instead of running through the catalog's
  // long sequence of tarantulas. Keep both photographs distinct.
  function nextProducts(buttons) {
    const catalog = (window.ZDATA?.products || []).filter(available);
    const fromPool = nextPoolProducts(buttons, catalog);
    if (fromPool.length) return fromPool;
    const groups = new Map();
    catalog.forEach(p => {
      if (!groups.has(p.category)) groups.set(p.category, []);
      groups.get(p.category).push(p);
    });
    const lanes = [...groups.entries()];
    const excluded = new Set(buttons.map(n => n.dataset.zQuick));
    const picks = [];
    for (let i = 0; i < lanes.length * buttons.length && picks.length < buttons.length; i++) {
      const [category, items] = lanes[groupOffset++ % lanes.length];
      const start = productOffsets.get(category) || 0;
      for (let j = 0; j < items.length; j++) {
        const index = (start + j) % items.length, p = items[index];
        if (excluded.has(p.id)) continue;
        picks.push(p); excluded.add(p.id); productOffsets.set(category, (index + 1) % items.length); break;
      }
    }
    if (picks.length !== buttons.length) return [];
    return picks;
  }
  // Photos are requested up to 2000px wide so they stay sharp on large and high-density
  // screens. Shopify never upscales, so a smaller original simply comes back at its own size.
  function imageSource(p) {
    const url = new URL(p.image, location.href);
    url.searchParams.set('width', '1200');
    return url.href;
  }
  function responsiveSources(p) {
    const url = new URL(p.image, location.href);
    return [600, 900, 1200, 1600, 2000].map(width => { url.searchParams.set('width', width); return url.href + ' ' + width + 'w'; }).join(', ');
  }
  function loadPhoto(p, button) {
    return new Promise(resolve => {
      const img = new Image(), timeout = setTimeout(() => finish(false), 6000);
      const finish = loaded => { clearTimeout(timeout); img.onload = img.onerror = null; resolve(loaded); };
      img.onload = () => img.decode().then(() => finish(true), () => finish(false)); img.onerror = () => finish(false);
      img.sizes = $('img', button).sizes; img.srcset = responsiveSources(p); img.src = imageSource(p);
    });
  }
  async function renderPhoto(button, p, token) {
    const img = $('img', button);
    const previous = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.alt, focal: img.style.objectPosition };
    const outgoing = img.cloneNode();
    outgoing.loading = 'eager';
    try { await outgoing.decode(); } catch { return; }
    if (token !== revision || !canRotate()) return;
    outgoing.classList.add('zx-hero-outgoing');
    outgoing.alt = ''; outgoing.setAttribute('aria-hidden', 'true'); outgoing.removeAttribute('id');
    img.after(outgoing);
    // A fully opaque incoming image stays behind the old image throughout the
    // dissolve. This avoids the dark flash from fading a single replacement.
    img.srcset = responsiveSources(p);
    img.src = imageSource(p); img.alt = p.imageAlt || [p.name, p.latin].filter(Boolean).join(', ');
    img.style.objectPosition = p.imageFocalPoint || '50% 50%';
    const options = (p.variants || []).map((v, i) => ({ ...v, i })).filter(v => v.available).sort((a, b) => Number(a.price) - Number(b.price));
    return new Promise(resolve => {
      let committed = false, finished = false;
      const commit = () => {
        if (committed || finished) return;
        committed = true;
        button.dataset.zQuick = p.id; button.dataset.zVi = String(options[0].i); button.disabled = false;
        button.setAttribute('aria-label', 'Meet ' + p.name);
        $('.zx-hero-peek strong', button).textContent = p.name;
        $('.zx-hero-peek em', button).textContent = p.latin || '';
        $('.zx-hero-peek small', button).textContent = (p.spice ? 'Spice ' + p.spice : 'Animal') + ' · ' + p.priceLabel;
      };
      const animation = outgoing.animate([{ opacity: 1 }, { opacity: 0 }], { duration: fadeDuration, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' });
      const caption = $('.zx-hero-peek > span:first-child', button).animate([
        { opacity: 1, offset: 0 }, { opacity: 1, offset: .3 }, { opacity: 0, offset: .5 }, { opacity: 1, offset: .7 }, { opacity: 1, offset: 1 }
      ], { duration: fadeDuration, easing: 'ease-in-out' });
      // The name and click target switch together as the new photo becomes
      // dominant. Hover/focus settles on that same animal before interaction.
      const midpoint = setTimeout(commit, fadeDuration / 2);
      const cleanup = () => {
        if (finished) return;
        finished = true; clearTimeout(midpoint); animation.cancel(); caption.cancel(); outgoing.remove(); transitions.delete(button); resolve();
      };
      const settle = () => {
        if (finished) return;
        if (!committed) {
          if (previous.srcset) img.setAttribute('srcset', previous.srcset); else img.removeAttribute('srcset');
          img.setAttribute('src', previous.src); img.alt = previous.alt; img.style.objectPosition = previous.focal;
        }
        cleanup();
      };
      transitions.set(button, { settle });
      animation.finished.then(() => { commit(); cleanup(); }, settle);
    });
  }
  async function rotatePhotos() {
    if (!canRotate()) return;
    const token = revision, buttons = photoButtons(), products = nextProducts(buttons);
    if (products.length && (await Promise.all(products.map((p, i) => loadPhoto(p, buttons[i])))).every(Boolean) && token === revision && canRotate()) {
      await Promise.all(buttons.map((button, i) => renderPhoto(button, products[i], token)));
    }
    if (token === revision) schedule();
  }
  $$('[data-zx-hero-animal]').forEach(button => {
    button.addEventListener('mouseenter', schedule); button.addEventListener('mouseleave', schedule);
    button.addEventListener('focusin', schedule); button.addEventListener('focusout', () => queueMicrotask(schedule));
  });
  document.addEventListener('visibilitychange', schedule);
  reduced.addEventListener('change', () => setPaused(reduced.matches));
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? visiblePhotos.add(entry.target) : visiblePhotos.delete(entry.target));
    visible = photoButtons().some(button => visiblePhotos.has(button)); schedule();
  });
  // Watch the visible animal photo rather than the entire tall mobile hero.
  $$('[data-zx-hero-animal]').forEach(button => visibility.observe(button));
  const dialogs = new MutationObserver(schedule);
  document.querySelectorAll('dialog').forEach(dialog => dialogs.observe(dialog, { attributes: true, attributeFilter: ['open'] }));
  // Stories change on request; animal photographs rotate within the selected story.
  function setStory(index, manual = false) {
    const next=Number(index);if(!Number.isFinite(next))return;story=((Math.trunc(next)%slides.length)+slides.length)%slides.length;
    radios.forEach((n,i) => n.checked = i === story);
    slides.forEach((n,i) => { n.inert = i !== story; n.setAttribute('aria-hidden', String(i !== story)); });
    dots.forEach((n,i) => n.setAttribute('aria-current', String(i === story)));
    storyButtons.forEach(n => n.setAttribute('aria-pressed', String(Number(n.dataset.zxStory) === story)));
    $$('.bzn-browse-hero__caption').forEach((n,i) => n.setAttribute('aria-hidden', String(i !== story)));
    const current=$('[data-bzn-hero-current]');if(current)current.textContent=String(story+1).padStart(2,'0');
    const status = $('[data-bzn-hero-status]');
    if (status) { status.setAttribute('aria-live', manual ? 'polite' : 'off'); status.textContent = ['The fellas','Their world','Real care'][story] + ' · ' + (story + 1) + ' of '+slides.length; }
    visible = photoButtons().some(button => visiblePhotos.has(button));
    schedule();
  }
  radios.forEach((n,i) => n.addEventListener('change', () => n.checked && setStory(i,true)));
  storyButtons.forEach(n => n.onclick = () => setStory(n.dataset.zxStory,true));
  dots.forEach((n,i) => n.onclick = () => setStory(i,true));
  [['[data-bzn-hero-prev]',-1],['[data-bzn-hero-next]',1]].forEach(([selector,delta]) => {
    const button = $(selector); if (button) { button.hidden = false; button.onclick = () => setStory(story + delta,true); }
  });
  hero.removeAttribute('data-bzn-hero-autoplay');
  setStory(0);
  window.HeroUI = {
    setStory:index => setStory(index,true),
    pause:() => setPaused(true),
    resume:() => setPaused(false),
    getState:() => ({story, paused, rotating:canRotate(), interval, animalIds:photoButtons().map(n=>n.dataset.zQuick)})
  };
})();
